// removed by extract-text-webpack-plugin
module.exports = {"column":"_3ree_K5IqqRplm9ZNv5FPI","buttonContainer":"_1nzum6G1134ar1Ly720gV6","description":"_3c95opUX1O34teqynpCVC0"};